<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Bug Report :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                    <li class="breadcrumb-item active">Bug</li>
                </ol>
            </h4>

            <template v-if="bugSubmitted">
                <div class="alert alert-success">
                    <p><strong>Bug Submitted:</strong> Your bug submission has been sent to the EHS team. You'll receive an email with a ticket number soon.</p>
                    <router-link to="/" class="btn btn-success mt-2">
                        Back to Dashboard
                    </router-link>
                </div>
            </template>
            <template v-else>
                <div class="row">
                    <div class="col-lg-8 col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.bug_subject }" class="row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Subject: <i class="fa fa-asterisk text-danger"></i>
                                    </label>
                                    <div class="col-sm-8">
                                        <input :class="{'is-invalid': errors.bug_subject}" type="text" name="bug_subject" v-model="bug.bug_subject" placeholder="Subject or title for this bug request" class="form-control" />
                                        <span v-if="errors.bug_subject" class="text-danger">
                                            <span v-for="error in errors.bug_subject">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.bug_url }" class="row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    URL: <i class="fa fa-asterisk text-danger"></i>
                                    </label>
                                    <div class="col-sm-8">
                                        <input :class="{'is-invalid': errors.bug_url}" type="text" name="bug_url" v-model="bug.bug_url" placeholder="Web URL" class="form-control" />
                                        <span>Copy and paste the url of the page where your bug or question occurs.</span>
                                        <span v-if="errors.bug_url" class="text-danger">
                                            <br>
                                            <span v-for="error in errors.bug_url">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.bug_description }" class="row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                      Description: <i class="fa fa-asterisk text-danger"></i>
                                    </label>
                                    <div class="col-sm-8">
                                        <textarea :class="{'is-invalid': errors.bug_description}" name="bug_description" v-model="bug.bug_description" placeholder="Description of the issue" class="form-control" style="min-height: 150px;" />
                                        <span v-if="errors.bug_description" class="text-danger">
                                            <span v-for="error in errors.bug_description">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.files }" class="row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Files</label>
                                    <div class="col-sm-8">

                                        <b-form-file v-model="files" class="mt-3" plain multiple></b-form-file>

                                        <span v-if="errors.files" class="text-danger">
                                            <span v-for="error in errors.files">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <div class="card">
                            <div class="card-header">Ticket Portal</div>
                            <div class="card-body">
                                <p>To better serve our customers, MeritEHS uses a ticketing system call JIRA. While you can still submit tickets/bugs here via the form, logging into the portal directly will allow you to:</p>
                                <ul>
                                    <li>Comment on existing tickets</li>
                                    <li>Upload files to existing tickets</li>
                                    <li>Create New Tickets</li>
                                    <li>Collaborate on tickets with other users</li>
                                </ul>
                                <p class="alert alert-warning">
                                    <strong>Note:</strong> You must be manually added to the portal by MeritEHS support. If you have submitted a ticket before, you are already in the portal. If not, submit your first ticket from the form here and you'll be added ASAP.
                                </p>
                                <a href="https://merittechnologies.atlassian.net/servicedesk/customer/portals" _target="blank" class="btn btn-primary">Go to JIRA Portal</a>
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>
                <button type="button" class="btn btn-success" v-on:click="saveBug(this)" :disabled="saving">
                    Submit
                </button>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: false,
                saving: false,
                bugSubmitted: false,
                bug: {},
                files: [],
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            saveBug: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .postWithFiles('bug', this.bug, this.files)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Bug Submitted');

                    //Return to main list?
                    //this.$router.push('/');
                    this.bugSubmitted = true;
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        }
    }
</script>
